import { useParams } from 'react-router-dom';
import FileManager from '../components/FileManager';

function SlovakCycle() {
  const params = useParams();
  const cycleId = params.cycleId;  
  const folderId = "slovak-" + cycleId;
  const folderName = cycleId + ". cyklus";

  return <>
    <FileManager folderId={folderId} folderName={folderName} />
  </>
}

export default SlovakCycle;